import { createContext, useContext, useEffect, useState, useCallback } from "react";
import {
  api,
  formatApiErrorDetail,
  getStoredAccessToken,
  setStoredTokens,
  clearStoredTokens,
} from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [error, setError] = useState("");

  const check = useCallback(async () => {
    if (!getStoredAccessToken()) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      clearStoredTokens();
      setUser(false);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const sendOtp = async (phoneNumber) => {
    setError("");
    try {
      await api.post("/otp/send", { phone_number: phoneNumber });
      return true;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const verifyOtp = async (phoneNumber, otp) => {
    setError("");
    try {
      const { data } = await api.post("/otp/verify", { phone_number: phoneNumber, otp });
      setStoredTokens(data);
      const { data: me } = await api.get("/auth/me");
      setUser(me);
      return true;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const logout = async () => {
    clearStoredTokens();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, error, sendOtp, verifyOtp, logout, refresh: check }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
